var clickMenuVertical = function() {
        if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
            $('.vertical-menu .categories-title__button').off('click.hideVertical').on('click.hideVertical', function() {
                $('.vertical-menu').toggleClass('vertical-menu__hide vertical-menu__open');
            });
        }
    }
    
    $(document).ready(function() {
        clickMenuVertical();
    });